export default __webpack_public_path__ + "images/5dec3c1ffc68260c0f7d4a00e9f68c1f-acima.svg";